import { ForwardedRef, ReactNode } from 'react';

import { Grid } from '@progress/kendo-react-grid';
import { createContext } from 'use-context-selector';

export interface GridContextValue {
  ref: ForwardedRef<Grid> | undefined;
  data?: any[];
}
export const GridContext = createContext<GridContextValue | null>(null);

type GridContextProviderProps = {
  children: ReactNode;
  value: GridContextValue;
};

const GridContextProvider = ({ children, value }: GridContextProviderProps) => (
  <GridContext.Provider value={value}>{children}</GridContext.Provider>
);

export default GridContextProvider;
